import React, { Component, Fragment } from 'react';

import Moment from 'moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PropTypes from 'prop-types';

import {
  SongRow
} from '../../components';

import {
  CitTable,
  AlbumH1,
  // AlbumH2,
  AlbumDivider,
  AlbumP
} from '../../components/HelperComponents/StyledComponents';

import { fetchNewAlbumsIfNeeded } from '../../actions/HomeActions';
import { fetchAlbumIfNeeded } from '../../actions/AlbumActions';
// todo
import {
  playlistReplace,
} from '../../actions/PlaylistActions';

import TuesdayCollectiveDefaultImg from '../../images/default-record.png';

import {
  getSonglistHash,
  stripUrlQueryParams,
} from '../../helpers';


const getCurrentAlbum = props => {
  return props.currentAlbum.album || {};
};

const getSongsFromAlbum = album => {
  return album.album_songs || [];
};

export class AlbumComponent extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  static propTypes = {
    items: PropTypes.array,
    currentAlbum: PropTypes.object
  };

  static defaultProps = {
    currentAlbum: {
      albumn_cover: {},
      album_songs: [],
      album: {
        title: {
          rendered: '...'
        }
      }
    }
  };

  checkForUpdatedSongs(props, prevProps) {
    // if (props.match.params.albumId !== prevProps.match.params.albumId) {

    const album = getCurrentAlbum(props);
    const albumPrev = getCurrentAlbum(prevProps);
    const songs = getSongsFromAlbum(album);
    const songsPrev = getSongsFromAlbum(albumPrev);

    if (getSonglistHash(songs) !== getSonglistHash(songsPrev)) {
      this.props.playlistReplace(songs);
    }
  }

  componentDidMount() {
    let { albumId } = this.props.match.params;
    this.props.fetchNewAlbumsIfNeeded();
    this.props.fetchAlbumIfNeeded(albumId, this.props.history);
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.albumId !== prevProps.match.params.albumId) {
      this.props.fetchAlbumIfNeeded(this.props.match.params.albumId, this.props.history);
    }

    this.checkForUpdatedSongs(this.props, prevProps);
  }

  renderSongs(pSongs) {
    const currentSongId = this.props.currentSong && this.props.currentSong.id;

    if (pSongs && pSongs.length) {
      return pSongs.map((song, i) => {
        const isActive = song.id === currentSongId;
        const isLoading = isActive && this.props.isLoading;
        const isPlaying = isActive && this.props.isPlaying;

        return (
          <SongRow
            key={'songRow_' + i}
            numeration={i}
            song={song}
            isActive={isActive}
            isLoading={isLoading}
            isPlaying={isPlaying}
            shouldShowAlbumCover={false}
            shouldLinkAlbumTitle={false}
          />
        );
      }
      );
    }
  }

  render() {
    const album = getCurrentAlbum(this.props);
    const songs = getSongsFromAlbum(album);
    const accum = {};

    songs.forEach(song => {
      let keys;
      let val;
      let valtxt;
      const styles = song.product_style;

      if (styles) {
        keys = Object.keys(styles);
        val = styles[keys[0]]
        if (!val) {
          return;
        }

        valtxt = val.post_title;
        accum[valtxt] = accum[valtxt] || {
          text: valtxt,
          count: 0,
        };

        accum[valtxt].count++;
      }
    });


    // for now, throw away the count... and just take the first one
    const stylesStringList = Object.keys(accum).map((key, val) => {
      return key;
    });

    const albumStyle = stylesStringList[0] || '...';
    const albumUrl = stripUrlQueryParams(album.albumn_cover.url || TuesdayCollectiveDefaultImg);

    return (
      <Fragment>
        <section className="column is-3 has-text-white">
          <figure className="image is-square">
            <img src={albumUrl} alt="Album Cover" />
          </figure>
          <AlbumH1>{album.title.rendered}</AlbumH1>
          <small>{albumStyle}</small>

          <AlbumDivider />

          <AlbumP>{songs.length} Songs</AlbumP>
          <AlbumP>Release Date: {Moment(album.date).format('LL').toString()}</AlbumP>
        </section>

        <section className="column is-8">
          <CitTable className="table is-fullwidth has-text-white album">
            <thead>
              <tr>
                <th className="has-text-white is-hidden-mobile">#</th>
                <th className="has-text-white is-hidden-mobile">Title</th>
                <th className="has-text-white is-hidden-mobile">Album</th>
                <th className="has-text-white is-hidden-mobile">Style</th>
                <th className="has-text-white is-hidden-mobile">Tempo</th>
                <th className="has-text-white is-hidden-mobile"></th>
              </tr>
            </thead>
            <tbody className="is-hoverable">
              {this.renderSongs(songs)}
              {album.isFetching ? <tr>
                <td colSpan="6">
                  Loading...
                </td>
              </tr> : null }

            </tbody>
          </CitTable>
        </section>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentAlbum,
    playlist,
    playerSong,
  } = state;

  const {
    isPlaying,
    isLoading,
    currentSong,
  } = playerSong || {
    currentSong: null,
  };

  return {
    currentAlbum,
    isPlaying,
    isLoading,
    playlist,
    currentSong,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchNewAlbumsIfNeeded,
    fetchAlbumIfNeeded,
    playlistReplace,
  }, dispatch);
}

export const Album = connect(mapStateToProps, mapDispatchToProps)(AlbumComponent);



// WEBPACK FOOTER //
// ./src/routes/Album/Album.js